import { render, staticRenderFns } from "./yyfx.vue?vue&type=template&id=c399356a&scoped=true"
import script from "./yyfx.vue?vue&type=script&lang=js"
export * from "./yyfx.vue?vue&type=script&lang=js"
import style0 from "./yyfx.vue?vue&type=style&index=0&id=c399356a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c399356a",
  null
  
)

export default component.exports